import React, { useState } from 'react';

const RegistrationForm = ({ onSubmit, isLoading }) => {
  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Username validation
    const usernameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

    if (!formData.userName.trim()) {
      newErrors.userName = "Username is required";
    }
    else if (formData.userName.length < 3) {
      newErrors.userName = "Username must be at least 3 characters long";
    }
    else if (formData.userName.length > 30) {
      newErrors.userName = "Username cannot exceed 30 characters";
    }
    else if (!usernameRegex.test(formData.userName)) {
      newErrors.userName = "Username must contain only alphabets and single spaces";
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    }
    else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Password validation 
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long";
    }
    else if (!passwordRegex.test(formData.password)) {
      newErrors.password =
        "Password must contain at least one alphabet, one number, and one special character";
    }

    // Confirm Password
    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm Password is required";
    }
    else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Password and Confirm Password do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Username Field */}
      <div>
        <label htmlFor="userName" className="block text-sm font-medium text-foreground mb-2">
          Username *
        </label>
        <input
          type="text"
          id="userName"
          name="userName"
          value={formData.userName}
          onChange={handleChange}
          className={`w-full px-4 py-3 h-11 border rounded-lg leading-[44px] bg-input text-foreground placeholder:text-muted-foreground focus:ring-brand focus:border-transparent transition duration-200 ${errors.userName ? 'border-destructive' : 'border-border'
            }`}
          placeholder="Enter your username"
          disabled={isLoading}
        />
        {errors.userName && (
          <p className="mt-1 text-sm text-destructive">{errors.userName}</p>
        )}
      </div>

      {/* Email */}
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
          Email Address *
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className={`w-full px-4 py-3 h-11 border leading-[44px] rounded-lg bg-input text-foreground placeholder:text-muted-foreground focus:ring-brand focus:border-transparent transition duration-200 ${errors.email ? 'border-destructive' : 'border-border'
            }`}
          placeholder="Enter your email"
          disabled={isLoading}
        />
        {errors.email && (
          <p className="mt-1 text-sm text-destructive">{errors.email}</p>
        )}
      </div>

      {/* Password */}
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-foreground mb-2">
          Password *
        </label>
        <input
          type="password"
          id="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          className={`w-full px-4 py-3 h-11 border leading-[44px] rounded-lg bg-input text-foreground placeholder:text-muted-foreground focus:ring-brand focus:border-transparent transition duration-200 ${errors.password ? 'border-destructive' : 'border-border'
            }`}
          placeholder="Enter your password"
          disabled={isLoading}
        />
        {errors.password && (
          <p className="mt-1 text-sm text-destructive">{errors.password}</p>
        )}
      </div>

      {/* Confirm Password */}
      <div>
        <label htmlFor="confirmPassword" className="block text-sm font-medium text-foreground mb-2">
          Confirm Password *
        </label>
        <input
          type="password"
          id="confirmPassword"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          className={`w-full px-4 py-3 h-11 border leading-[44px] rounded-lg bg-input text-foreground placeholder:text-muted-foreground focus:ring-brand focus:border-transparent transition duration-200 ${errors.confirmPassword ? 'border-destructive' : 'border-border'
            }`}
          placeholder="Confirm your password"
          disabled={isLoading}
        />
        {errors.confirmPassword && (
          <p className="mt-1 text-sm text-destructive">{errors.confirmPassword}</p>
        )}
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={isLoading}
        className={`w-full py-3 px-4 h-10 flex items-center justify-center border border-transparent rounded-lg shadow-card text-sm font-medium transition duration-200 ${isLoading
          ? 'bg-card text-muted-foreground cursor-not-allowed'
          : 'bg-brand text-on-primary hover:bg-brand-dark focus:outline-none'
          }`}
      >
        {isLoading ? (
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-on-primary mr-2"></div>
            Creating account...
          </div>
        ) : (
          'Create Account'
        )}
      </button>
    </form>
  );
};

export default RegistrationForm;
